/**
 * 30-min flash deal timer only.
 * Buy Now / sticky Buy is handled by checkout-link.js (→ .im draft invoice).
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-product-sticky]');
  var form = document.querySelector('[data-type="add-to-cart-form"]');

  var TIMER_KEY = 'tcg_flash_deal_ends_at';
  var flashEnabled = bar && bar.getAttribute('data-flash-enabled') === 'true';
  var minutes = bar ? parseInt(bar.getAttribute('data-flash-minutes') || '30', 10) || 30 : 30;
  var percent = bar ? parseInt(bar.getAttribute('data-flash-percent') || '10', 10) || 10 : 10;
  var basePrice = bar ? parseInt(bar.getAttribute('data-variant-price') || '0', 10) || 0 : 0;

  var timers = document.querySelectorAll('[data-flash-timer]');
  var dealEl = bar && bar.querySelector('[data-flash-deal]');
  var noteEl = document.querySelector('[data-flash-note]');
  var flashPriceEl = bar && bar.querySelector('[data-flash-price]');

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function endsAt() {
    try {
      var n = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10);
      if (n > Date.now()) return n;
      n = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(n));
      return n;
    } catch (e) {
      return Date.now() + minutes * 60 * 1000;
    }
  }

  function tick() {
    if (!flashEnabled) return;
    var left = endsAt() - Date.now();
    if (left <= 0) {
      timers.forEach(function (el) {
        el.textContent = '00:00';
      });
      if (dealEl) dealEl.classList.add('is-expired');
      if (noteEl) noteEl.classList.add('is-expired');
      return;
    }
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var label = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    timers.forEach(function (el) {
      el.textContent = label;
    });
    if (flashPriceEl) {
      flashPriceEl.textContent = money(Math.round((basePrice * (100 - percent)) / 100));
    }
  }

  if (flashEnabled) {
    tick();
    setInterval(tick, 1000);
  }

  var mainPrice = document.querySelector('[data-product-price]');
  var stickyPrice = bar && bar.querySelector('[data-sticky-price]');
  if (form && mainPrice && stickyPrice) {
    form.addEventListener('change', function () {
      setTimeout(function () {
        stickyPrice.textContent = mainPrice.textContent;
        var jsonEl = document.querySelector('[id^="ProductJson-"], [data-product-json]');
        var idInput = form.querySelector('[data-product-variant-id]');
        if (!jsonEl || !idInput) return;
        try {
          var product = JSON.parse(jsonEl.textContent);
          var v = product.variants.find(function (x) {
            return String(x.id) === String(idInput.value);
          });
          if (v) {
            basePrice = v.price;
            tick();
          }
        } catch (err) {}
      }, 0);
    });
  }
})();
